import { apiSlice } from '../../api/api';

// Inject auth endpoints into the base apiSlice
export const authApi = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // Login with email, password, and role
    login: builder.mutation({
      query: (credentials) => ({
        url: '/operations/login',
        method: 'POST',
        body: credentials,
      }),
      // Handle token storage after successful login
      async onQueryStarted(credentials, { queryFulfilled }) {
        console.log('Login credentials:', credentials);
        try {
          const { data } = await queryFulfilled;
          if (data.data && data.data.token) {
            localStorage.setItem('authToken', data.data.token);
          }
        } catch (error) {
          console.error('Login failed:', error);
        }
      },
    }),
  }),
});

// Export hooks for usage in components
export const {
  useLoginMutation,
} = authApi; 